// @owners { team: patients }
import { staleTimes } from '~shared/queries/constants';
import { QueryClient } from '~shared/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: staleTimes.fiveMinutes,
    },
  },
});
